import { Api, ApiRequest, ResType } from '@api'
import { Logger } from '@utils'

export const addAccessGroup = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/access-group'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
	}
}

export const getAccessGroup = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/access-group'
		const req = new ApiRequest({
			method: 'get',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const updateAccessGroup = async ({
	params = { id: '' },
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/access-group/${params.id}`
		const req = new ApiRequest({
			method: 'put',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
	}
}

export const updateAccessGroupUsers = async ({
	params = { id: '' },
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/access-group/${params.id}/users`
		const req = new ApiRequest({
			method: 'put',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
	}
}

export const deleteAccessGroup = async ({
	params = { id: '' },
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/access-group/${params.id}`
		const req = new ApiRequest({
			method: 'delete',
			uri: uri,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

const accessGroupApi = {
	addAccessGroup: addAccessGroup,
	getAccessGroup: getAccessGroup,
	updateAccessGroup: updateAccessGroup,
	updateAccessGroupUsers: updateAccessGroupUsers,
	deleteAccessGroup: deleteAccessGroup,
}

export default accessGroupApi
